<template>
  <div>
    <headBar />
    <div v-scroll-spy>
      <!-- hero section start -->
      <section class="section hero-section bg-ico-hero" id="home">
        <div class="bg-overlay bg-fica"></div>
      </section>

      <div class="container">
        <div class="card mt-4">
        <div class="row">
          <div class="col-lg-12">

              <div class="card-body">
                <h1 >Seguimiento al estudiante</h1><br>
                <h5 class="card-title ">Ingrese Codigo de estudiante</h5>

                <b-form inline>
                  <label class="sr-only">Name</label>
                  <b-input class="mr-sm-3 font-size-18" placeholder="" v-model="codigo_matricula"/>

                  <b-button   variant="primary" v-on:click="buscar()">
                    <b-spinner small v-show="isLoading" />
                    Buscar
                  </b-button>


                </b-form>
              </div>

          </div>
          <div class="col-md-12">
            <vue-recaptcha
                    class="m-1"
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    @expired="resetCaptcha"
                    sitekey="6Lf6YUEaAAAAAKy1HtxGVG3ZDVApRrpaqXJ8wxNR"
                    :loadRecaptchaScript="true"
                    data-size="compact"
                    :hl="es"
            />
          </div>
        </div>

        </div>

        <div class="card">
          <div class="row m-5 font-size-18"  >
            <table class="table table-bordered border-primary">
              <thead>
                <tr>
                  <th>Nombre encuesta</th>
                  <th>Carrera profesional</th>
                  <th>Respondio encuesta</th>
                  <th>URL</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in model" v-bind:key="index">
                <td>{{item.encuesta}}</td>
                <td>{{item.carrera}}</td>
                <td>{{item.lleno_encuesta}}</td>
                <td>
                  <a :href="getURL(item.google_form_id)" target="_blank"><h4><strong>Abrir encuesta</strong></h4></a>
                </td>
              </tr>
              </tbody>

            </table>

          </div>
        </div>



      </div>
      <!--

      <div style="height: 100vh;">
        <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSc4JNVJvFGt2h_ddTXR-VFaAg9S2yJePEMQfiCf0kIcgFkKQA/viewform?embedded=true"
                width="100%" height="100%"
                frameborder="0"
                marginheight="0"
                marginwidth="0">Cargando…</iframe>
      </div>
      -->


      <!-- Footer start -->
      <footer class="landing-footer">
        <div class="container">

          <!-- end row -->

          <hr class="footer-border my-5" />

          <div class="row">
            <div class="col-lg-6">
              <div class="mb-4">
                <img src="@/assets/images/logo-light2.png" alt height="20" />
              </div>
              <p
                class="mb-2"
              >{{ new Date().getFullYear() }} © FGlobal. </p>
              <p>-----------</p>
            </div>
          </div>

        </div>
        <!-- end container -->
      </footer>
      <!-- Footer end -->
    </div>
  </div>
</template>
<script>
  //import { Carousel, Slide } from "vue-carousel";
  import VueRecaptcha from 'vue-recaptcha';

  import  headBar from '@/components/head-bar';
  /**
   * Crypto ICO-landing page
   */

  export default {

    created() {
      window.addEventListener("scroll", this.windowScroll);

    },
    destroyed() {
      window.removeEventListener("scroll", this.windowScroll);
    },
    beforeMount() {

    },
    mounted() {
      if(!isNaN(this.$route.params.codigo_matricula)){
        this.codigo_matricula=this.$route.params.codigo_matricula;
      }

    },
    components: { VueRecaptcha ,  headBar},
    data() {
      return {
        model:{
        },
        token:'',
        codigo_matricula:'',
        isLoading:false

      };
    },


    methods: {
      getURL(google_form_id){
        return "/encuestas-externo/"+google_form_id
      },
      buscar(){
        if(this.token==''){
          this.$swal('Cuidado', 'Marque la casilla de verificacion que no es un robot!','warning')
          return;
        }
        this.isLoading=true;
        this.model={};
        this.axios.post(process.env.VUE_APP_BACKEND+'/buscar-encuesta-externo',
                {
                  'codigo_matricula':this.codigo_matricula,
                  'g-recaptcha-response':this.token,
                }
        ).then((response)=>{
          if(response.data.success)
          {
            this.model=response.data.model;
          }else
          {
            this.$swal('Cuidado', response.data.mensaje,'warning')
          }
        })
        .catch(()=>{
          this.$swal('Cuidado', 'HUbo un error procesado su solicitud','warning')
          this.$refs.recaptcha.reset();
          this.token='';
        })
        .finally(()=>{
          this.isLoading=false
          this.$refs.recaptcha.reset();
          this.token='';
        });
      },
      // eslint-disable-next-line no-unused-vars

      onCaptchaVerified(token){
        this.token=token;
      },
      resetCaptcha(){
        this.$refs.recaptcha.reset()
      },

      /**
       * Window scroll method
       */
      windowScroll() {
        const navbar = document.getElementById("navbar");
        if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      },

    }
  };
</script>
<style>
  .big-font{
    font-size: 14px !important;
    color: #000000;

  }
  .g-recaptcha {
    transform:scale(0.88);
    transform-origin:0 0;
  }


</style>
